import {
  ComponentParams,
  ComponentRendering,
  Field,
  LinkField,
  RichTextField,
} from '@sitecore-jss/sitecore-jss-nextjs';
import {
  DynamicPlaceholderParams,
  TranslationOptionsParams,
  AnchorTargetParams,
  ImagePropertiesParams,
} from 'src/shared/shared.types';

export interface C14SidePhotoContentCardCarouselProps {
  rendering?: ComponentRendering & {
    params?: ComponentParams;
    placeholders?: PhotoContentCardCarouselPlaceholder;
  };
  params?: ComponentParams & {
    TitleType?: string;
    ContentAlignment?: string;
    CTAStyle?: string;
    BackgroundColor?: string;
    SlideTiming?: number;
    SlideLayout?: string;
  } & DynamicPlaceholderParams &
    TranslationOptionsParams &
    AnchorTargetParams &
    ImagePropertiesParams;
  fields?: C14SidePhotoContentCardFields;
}

export interface C14SidePhotoContentCardFields {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  BottomSupportCopy?: RichTextField;
  CTA?: LinkField;
}

export interface PhotoContentCardCarouselPlaceholder {
  'side-photo-content-cards-{*}'?: {
    componentName?: string;
  }[];
}
